import React, { useEffect, useState } from 'react'
import GSTReport from './GSTReport'
import { useSearchParams } from 'react-router-dom'
import { gstReport } from '../../common/constants'
import HisabReport from './generateHisabReport/HisabReport'
import GSTReportV2 from './GSTReportV2'
import CreditReport from './CreditReport'
import CreditSummaryReportNew from './CreditSummaryReportNew'
import CreditUsageReport from './CreditUsageReport'
import BusAndCargoMemo from './BusAndCargoMemo'
import PartywiseTransactionReport from './PartywiseCreditLimitReport/PartywiseCreditLimitTransactionReport'
import PartywiseSummaryReport from './PartywiseCreditLimitReport/PartyCreditLimitSummaryReport'
import BranchwiseCollectionAndDispatchMemoCollection from './BranchwiseCollectionAndDispatchMemoCollection'
import FranchiseePendingTopayReport from './FranchiseePendingTopayReport/FranchiseePendingTopayReport'
import FranchiseeSettlementReport from './FranchiseeSettlementReport/FranchiseeSettlementReport'
import MpesaTransactionReport from './MpesaTransactionReport/MpesaTransactionReport'
import GSTReportV1 from './GSTReportV1'
import OGPLReport from './OGPLReport/OGPLReport'
import { BranchDueReport } from './BranchDueReport'
import { BranchPayable } from './BranchPayable'
import { BookingSummary } from './BookingSummary'
import { ProfileLossReport } from './ProfileLossReport'
import OGCLReport from './OGCLReport'
import GSTReportReturnFile from './GSTReportReturnFile'
import HisabReportNew from './generateHisabReport/HisabReportNew'
import CreditLimitUsageReportNew from './CreditLimitUsageReportNew'
import PartyCreditLimitTransactionReportNew from './PartywiseCreditLimitReport/PartyCreditLimitTransactionReportNew'
import FranchiseePendingTopayReportNew from './FranchiseePendingTopayReport/FranchiseePendingTopayReportNew'
import FranchiseesettlementReportNew from './FranchiseeSettlementReport/FranchiseesettlementReportNew'
const AcountingReport = () => {
  const [searchParams] = useSearchParams()
  const [acountingNumber, setAcountingNumber] = useState(Number(searchParams.get('id')) || '')
  useEffect(() => {
    setAcountingNumber(Number(searchParams.get('id')))
  }, [searchParams])
  let acountingType
  switch (acountingNumber) {
    case 1: {
      acountingType = <GSTReportReturnFile />
      break
    }
    case 2: {
      acountingType = <GSTReportV2 />
      break
    }
    case 3: {
      acountingType = <CreditReport />
      break
    }
    case 4: {
      acountingType = <CreditSummaryReportNew />
      break
    }
    case 5: {
      acountingType = <CreditLimitUsageReportNew />
      break
    }
    case 6: {
      acountingType = <HisabReportNew />
      break
    }
    case 7: {
      acountingType = <BusAndCargoMemo />
      break
    }
    case 8: {
      acountingType = <PartyCreditLimitTransactionReportNew />
      break
    }
    case 9: {
      acountingType = <PartywiseSummaryReport />
      break
    }
    case 10: {
      acountingType = <FranchiseePendingTopayReportNew />
      break
    }
    case 11: {
      acountingType = <FranchiseesettlementReportNew />
      break
    }
    case 12: {
      acountingType = <MpesaTransactionReport />
      break
    }
    case 13: {
      acountingType = <BranchwiseCollectionAndDispatchMemoCollection/>
      break
    }
    case 14: {
      acountingType = <BranchDueReport/>
      break
    }
    case 15: {
      acountingType = <BranchPayable/>
      break
    }
    case 16: {
      acountingType = <BookingSummary/>
      break
    }
    case 17: {
      acountingType = <ProfileLossReport/>
      break
    }
    case 18: {
      acountingType = <OGPLReport/>
      break
    }
    case 19: {
      acountingType = <OGCLReport/>
      break
    }
    case 20: {
      acountingType = <GSTReportV1/>
      break
    }
    default:
      acountingType = <GSTReportReturnFile />
      break
  }
  return acountingType
}

export default AcountingReport
